export default {
  title: 'Nuova categoria',
  form: {
    menus: {
      label: 'Menu',
    },
    printer: {
      label: 'Stampante',
    },
    type: {
      label: 'Tipo',
    },
    name: {
      label: 'Nome',
      placeholder: 'Inserisci nome categoria',
    },
    description: {
      label: 'Descrizione',
      placeholder: 'Inserisci descrizione',
    },
    has_combo_tax: {
      label: 'Ha tassa combo',
    },
    modifier_groups: {
      label: 'Gruppi modificatori',
    },
    image: {
      label: 'Immagine',
    },
    identifiers: {
      label: 'Identificatori',
    },
    has_separate_schedule: {
      label: 'Varia dal piano menu',
    },
  },
  buttons: {
    save: 'Salva',
    close: 'Chiudi',
  },
  feedback: {
    missing_info: 'Informazioni mancanti',
  },
  toasts: {
    category_got_created: 'Categoria creata',
    category_got_updated: 'Categoria aggiornata',
  },
};
